<template>
  <div class="feedback-box"  >
    <div class="d-flex justify-content-between align-items-center">
      <div class="font-weight-bold">{{ 'Feedback' | trans }}</div>
      <div class="text-muted">
        {{ 'Help us improve' | trans }}
      </div>
    </div>
    <div class="rating-container">

      <div class="d-flex feedback-thumbs" v-if="true === false">
        <div class="w-100">
          <div class="feedback-btn w-100" @click="openFeedbackModal">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <path fill="none" stroke="currentColor" stroke-dasharray="80" stroke-dashoffset="80"
                    stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M7 11L12 3L15 4L14 10H21V13L18 20H7H3V11H7V20">
                <animate fill="freeze" attributeName="stroke-dashoffset" dur="0.8s" values="80;0"/>
              </path>
            </svg>
            {{ 'Good result' | trans }}
          </div>
        </div>
        <div class="w-100">
          <div class="feedback-btn w-100" @click="openFeedbackModal">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <path fill="none" stroke="currentColor" stroke-dasharray="80" stroke-dashoffset="80"
                    stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M7 4H18L21 11V14H14L15 20L12 21L7 13H3V4H7V13">
                <animate fill="freeze" attributeName="stroke-dashoffset" dur="0.8s" values="80;0"/>
              </path>
            </svg>
            {{ 'Not satisfied' | trans }}
          </div>
        </div>
      </div>

      <router-link
          v-slot="{ href, route, navigate, isActive, isExactActive }"
          :to="{ name: 'Feedback', params: { uuid: id } }"
          :class="'flex-grow-1'"
      >
        <div class="feedback-btn w-100 d-inline-flex justify-content-between" @click="navigate">
          <div class="feedback-text">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <g fill="none" fill-rule="evenodd">
                <path
                    d="M24 0v24H0V0zM12.594 23.258l-.012.002l-.071.035l-.02.004l-.014-.004l-.071-.036c-.01-.003-.019 0-.024.006l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.016-.018m.264-.113l-.014.002l-.184.093l-.01.01l-.003.011l.018.43l.005.012l.008.008l.201.092c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022m-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.003-.011l.018-.43l-.003-.012l-.01-.01z"/>
                <path fill="currentColor"
                      d="m20.255 5.52l.087.298l.089.338l.044.185l.089.4l.085.443l.081.485c.026.169.05.345.074.528l.065.572c.08.791.131 1.7.131 2.731s-.05 1.94-.13 2.731l-.066.572c-.023.183-.048.36-.074.528l-.08.485l-.086.443l-.089.4l-.089.36l-.088.317l-.043.144c-.331 1.087-1.464 1.505-2.394 1.195l-1.18-.393l-.4.933a2 2 0 0 1-2.47 1.11l-5.096-1.7a2 2 0 0 1-1.206-2.684l.269-.628L7 15.055l-1.368.456A2 2 0 0 1 3 13.613V9.388A2 2 0 0 1 5.632 7.49L7 7.946l10.861-3.62c.93-.31 2.063.107 2.394 1.194M9.682 15.948l-.335.78l5.096 1.7l.335-.781zm8.706-9.69L8 9.721v3.558l10.388 3.463l.077-.283l.08-.327l.04-.18l.078-.394a17.8 17.8 0 0 0 .076-.439l.07-.485c.112-.847.191-1.887.191-3.134c0-1.246-.08-2.287-.19-3.134l-.071-.485c-.025-.154-.05-.3-.076-.44l-.079-.393l-.08-.349zM5 9.388v4.225l1-.334V9.721z"/>
              </g>
            </svg>
            {{ 'Give us your feedback' | trans }}
          </div>
          <div>
            <i class="far fa-arrow-right"></i>
          </div>
        </div>
      </router-link>



      <div class="alert alert-info feedback-info" v-if="currentJob.feedback.submitted === true">{{ 'Thank you for giving us your feedback.'}}</div>
    </div>
  </div>
</template>
<script>
import store from './../../mixins/store.mixin'
import currentJob from './../../mixins/current_job.mixin'
import {EventBus} from '../../events/event.bus';
import {OPEN_FEEDBACK_MODAL} from '../../events/app.events';
import FeedbackManager from "../../manager/FeedbackManager";
import Analytics from "../../util/Analytics";

export default {
  name: "Feedback",
  props: {},
  components: {},
  mixins: [
    store,
    currentJob,
  ],
  data() {
    return {};
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {
    openFeedbackModal() {
      EventBus.$emit(OPEN_FEEDBACK_MODAL, {});
    },
    giveRating(rating)
    {
      if (this.currentJob.feedback.submitted === true) {
        return;
      }
      Analytics.send('result_feedback', 'rating_quick', this.currentJob);

      FeedbackManager.submitFeedback(this.currentJob, rating, '')
    }
  },
  computed: {}
};
</script>
<style lang="scss" scoped>
.feedback-box {
  .feedback-thumbs {
    gap: 10px;
    justify-content: space-evenly;
  }

  .rating-container {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .feedback-text {
    gap: 10px;
    display: inline-flex;
    align-items: center;
  }

  gap: 20px;
  display: flex;
  flex-direction: column;

  .feedback-btn {
    display: inline-flex;
    background: #F8F9FA;
    border: 1px solid #CBCBCB;
    border-radius: 4px;
    gap: 10px;
    padding: 10px 20px;
    align-items: center;
    cursor: pointer;

    .dark-mode & {
      background: #383838;;
      border: 1px solid #595959;
      color: white;

      &:hover {
        background: #323232;
      }
    }

    &:hover {
      background: #F2F2F2;
    }
  }

  .feedback-btn-star-1 {
    &.active {
      background: #fcc9c9 !important;
    }
    &:hover {
      background: #fcc9c9 !important;
    }
  }

  .feedback-btn-star-2 {
    &.active {
      background: #FFDADA !important;
    }
    &:hover {
      background: #FFDADA !important;
    }
  }

  .feedback-btn-star-3 {
    &.active {
      background: #FFF1D6 !important;
    }
    &:hover {
      background: #FFF1D6 !important;
    }
  }

  .feedback-btn-star-4 {
    &.active {
      background: #CCF4DC !important;
    }
    &:hover {
      background: #CCF4DC !important;
    }
  }

  .feedback-btn-star-5 {
    &.active {
      background: #b8f6d4 !important;
    }
    &:hover {
      background: #b8f6d4 !important;
    }
  }

  .feedback-btn-star {
    display: inline-flex;
    background: #F8F9FA;
    border: 1px solid #CBCBCB;
    border-radius: 4px;
    gap: 5px;
    padding: 10px 10px;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    &.disabled {
      cursor: not-allowed;
    }
    .dark-mode & {
      border: 1px solid #595959;
      color: white;

      &:hover {

      }
    }

    &:hover {
      background: #F2F2F2;
    }
  }
}
</style>
